import api from '../config/axios-conf';

export const getFeedbacksByDate = (date, params) =>
    api.get(`/feedbacks/date/${date}`, { params });

export const getAllFeedbacks = (params) =>
    api.get('/feedbacks/feedbackAll', { params });

export const updateFeedback = (id, data) =>
    api.put(`/feedbacks/${id}`, data);

export const deleteFeedback = (id) =>
    api.delete(`/feedbacks/${id}`);

export const getBillsWithQr = (params) =>
    api.get('/bills/billAll', { params });

export const updateQrStatus = (billId) =>
    api.put(`/bills/isFeedback/${billId}`);
